import OutletAction from '../../prat_actions/gt/outletAction'

const OutletReducer = (state = {isOutletLoading: true,outletSummary:[],isOutletExcludeLoading:false,excludeOutlet:[],
    isOutletExcludeFromSummaryLoading:false, excludeOutletFromSummary:[], excludeOutletForApprovalScreen:[], gettingOutlets:false }, action ) => {
    switch (action.type) {
        case  OutletAction.OUTLET_PROGRAM_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.OUTLET_PROGRAM_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                outletProgram: action.data
            };

        case  OutletAction.OUTLET_PROGRAM_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

        // Location Type

        case  OutletAction.LOCATION_TYPE_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.LOCATION_TYPE_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                locationType: action.data
            };

        case  OutletAction.LOCATION_TYPE_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

        // Tier

        case  OutletAction.TIER_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.TIER_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                tier: action.data
            };

        case  OutletAction.TIER_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

             // Perfect village

        case  OutletAction.PERFECT_VILLAGE_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.PERFECT_VILLAGE_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                perfectVillage: action.data
            };

        case  OutletAction.PERFECT_VILLAGE_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

        // Channel TTs

        case  OutletAction.CHANNEL_TTS_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.CHANNEL_TTS_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                channelTts: action.data
            };

        case  OutletAction.CHANNEL_TTS_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

        // Chain outlets

        case  OutletAction.CHAIN_OUTLETS_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.CHAIN_OUTLETS_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                chainOutlets: action.data
            };

        case  OutletAction.CHAIN_OUTLETS_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

        // Perfewct Store

        case  OutletAction.PERFECT_STORE_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.PERFECT_STORE_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                perfectStore: action.data
            };

        case  OutletAction.PERFECT_STORE_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

                // Perfect Store Compliance

        case  OutletAction.PERFECT_STORE_COMPLIANCE_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.PERFECT_STORE_COMPLIANCE_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                perfectStoreCompliance: action.data
            };

        case  OutletAction.PERFECT_STORE_COMPLIANCE_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

     // Outlet Classification

        case  OutletAction.OUTLET_CLASSIFICATION_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.OUTLET_CLASSIFICATION_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                outletClassification: action.data
            };

        case  OutletAction.OUTLET_CLASSIFICATION_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

        // Range

        case  OutletAction.RANGE_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.RANGE_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                range: action.data
            };

        case  OutletAction.RANGE_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

        // Point Of Consumption

        case  OutletAction.POINT_OF_CONSUMPTION_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.POINT_OF_CONSUMPTION_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                pointOfConsumption: action.data
            };

        case  OutletAction.POINT_OF_CONSUMPTION_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };

         // Loyality Program

         case  OutletAction.LOYALITY_PROGRAM_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.LOYALITY_PROGRAM_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                loyalityProgram: action.data
            };

        case  OutletAction.LOYALITY_PROGRAM_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };
        
             // Customer Attribute

        case  OutletAction.CUSTOMER_ATTRIBUTE_REQUEST :
            return {
                ...state,
                isOutletLoading:false,
            };

        case  OutletAction.CUSTOMER_ATTRIBUTE_SUCCESS :
            return {
                ...state,
                isOutletLoading:false,
                customerAttribute: action.data
            };

        case  OutletAction.CUSTOMER_ATTRIBUTE_FAILED :
            return {
                ...state,
                isOutletLoading:false,
                error:action.error
            };
        
            // OUTLET SUMMARY

       case  OutletAction.OUTLET_SUMMARY_REQUEST :
           return {
               ...state,
               isOutletSummaryLoading:true,
               outletSummary:[]
           };

       case  OutletAction.OUTLET_SUMMARY_SUCCESS :
           return {
               ...state,
               isOutletSummaryLoading:false,
               outletSummary: action.data
           };

       case  OutletAction.OUTLET_SUMMARY_FAILED :
           return {
               ...state,
               isOutletSummaryLoading:false,
               error:action.error,
               outletSummary:[]
           };
        
           // EXCLUDE OUTLET FILTER

      case  OutletAction.EXCLUDE_OUTLET_FILTER_REQUEST :
          return {
              ...state,
              isOutletExcludeLoading:true,
              excludeOutlet:[]
          };

      case  OutletAction.EXCLUDE_OUTLET_FILTER_SUCCESS :
          return {
              ...state,
              isOutletExcludeLoading:false,
              excludeOutlet: action.data
          };

      case  OutletAction.EXCLUDE_OUTLET_FILTER_FAILED :
          return {
              ...state,
              isOutletExcludeLoading:false,
              error:action.error,
              excludeOutlet:[]
          };
        
          // EXCLUDE OUTLET FROM SUMMARY

     case  OutletAction.EXCLUDE_OUTLET_FROM_SUMMARY_REQUEST :
         return {
             ...state,
             isOutletExcludeFromSummaryLoading:true,
             excludeOutletFromSummary:[]
         };

     case  OutletAction.EXCLUDE_OUTLET_FROM_SUMMARY_SUCCESS :
         return {
             ...state,
             isOutletExcludeFromSummaryLoading:false,
             excludeOutletFromSummary: action.data
         };

     case  OutletAction.EXCLUDE_OUTLET_FROM_SUMMARY_FAILED :
         return {
             ...state,
             isOutletExcludeFromSummaryLoading:false,
             error:action.error,
             excludeOutletFromSummary:[]
         };
        
         // EXCLUDE OUTLET FOR APPROVAL SCREEN

    case  OutletAction.GET_EXCLUDE_OUTLET_REQUEST :
        return {
            ...state,
            gettingOutlets:true,
            excludeOutletForApprovalScreen:[]
        };

    case  OutletAction.GET_EXCLUDE_OUTLET_SUCCESS :
        return {
            ...state,
            gettingOutlets:false,
            excludeOutletForApprovalScreen: action.data
        };

    case  OutletAction.GET_EXCLUDE_OUTLET_FAILED :
        return {
            ...state,
            gettingOutlets:false,
            error:action.error,
            excludeOutletForApprovalScreen:[]
        };

        default :
          return {
              ...state
          };
    }
}

export default OutletReducer;